<template>
  <div class="card-base p-5 transition duration-500 hover:-translate-y-1 hover:border-accent/60"
       :style="{ boxShadow: 'none' }">
    <slot />
  </div>
</template>
